import Image from 'next/image';
import Link from 'next/link';

/**
 * LaunchHeader — minimal chrome for /launch.
 *
 * The launch page deliberately drops the global marketing Navigation (mega-menu,
 * Resources, Pricing, Book a Demo) so a visitor arriving from Product Hunt or a
 * launch post has exactly two moves: go home, or sign up. Same reasoning as
 * IwfHeader on /iwf-2026 — the difference is that this one carries a CTA, since
 * /launch is a conversion surface rather than a booth flyer.
 *
 * The sign-up button renders unconditionally. The global nav gates its SIGN UP
 * behind NEXT_PUBLIC_SIGNUP, which is off in production — that gate is about
 * whether to advertise self-serve across the whole site, not about whether the
 * route works. /signup 301s to /create-account (see next.config.js), so this
 * links straight at the canonical destination and skips the hop.
 *
 * Not fixed/sticky: the hero's own CTAs carry the fold, and a sticky bar on a
 * page this long steals vertical space from the product captures.
 */
export function LaunchHeader() {
  return (
    <header className='absolute top-0 inset-x-0 z-40'>
      <div className='container mx-auto flex items-center justify-between gap-4 px-6 py-6 md:px-12 md:py-7'>
        <Link
          href='/'
          aria-label='TimberCloud home'
          className='inline-flex items-center gap-3 text-xl font-light tracking-[0.2em] text-white transition-opacity hover:opacity-80 md:text-2xl'
        >
          <Image
            src='/icons/logo-jade.png'
            alt=''
            width={32}
            height={32}
            className='h-8 w-8 shrink-0'
            priority
          />
          <span>
            TIMBER<span className='text-jade-deep'>CLOUD</span>
          </span>
        </Link>

        {/* Matches the hero's primary CTA exactly — bg-jade-cta with
            text-obsidian, pill, same hover. jade-cta is a bright jade, so dark
            text clears contrast comfortably where white did not. */}
        <Link
          href='/demo'
          className='shrink-0 rounded-full bg-jade-cta px-6 py-2.5 font-semibold text-obsidian transition-colors hover:bg-jade-cta-deep md:px-7 md:py-3'
        >
          Book a demo
        </Link>
      </div>
    </header>
  );
}

export default LaunchHeader;
